<template>
  <div>
    <v-menu
      offset-y
      :close-on-content-click="false"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          text
          class="text-body-1"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon small class="pr-2">fa-filter</v-icon>
          Filtro avançado
        </v-btn>
      </template>
      <v-list class="menu-container">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Status</v-list-item-title>
            <div class="d-flex align-start justify-center">
              <v-select
                v-model="statusFilter"
                label="Selectione status"
                :items="statusLabels"
                @change="handleChangeStatusOption"
                solo
                outlined
                dense
                flat
              ></v-select>
            </div>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Numero Lote</v-list-item-title>
            <v-text-field
              solo
              @input="handleNumeroLote"
              :value="numeroLote"
            ></v-text-field>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Numero Protocolo</v-list-item-title>
            <v-text-field
              solo
              @input="handleNumeroProtocolo"
              :value="numeroProtocolo"
            ></v-text-field>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-tooltip right v-if="statusFilter !== ''">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          icon
          @click="handleClearFilter"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon small class="pr-2">fa-minus</v-icon>
        </v-btn>
      </template>
      <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
        Remover filtro
      </span>
    </v-tooltip>
  </div>
</template>

<script>
import { conciliacaoClient } from '../../../libs'
import { pagamentoLoteStatusLabels } from '../../../libs/pagamento-lote-status-labels'

export default {
  props: {
    pagamentoId: String
  },
  data() {
    return {
      pagamentoLoteStatusLabels,
      statusFilter: '',
      statusCount: {},
      numeroLote: '',
      numeroProtocolo: ''
    }
  },
  methods: {
    handleClearFilter () {
      this.statusFilter = ''
      return this.$emit('clearFilter')
    },
    handleChangeStatusOption(newValue) {
      return this.$emit('changeFilter', {
        status: newValue
      })
    },
    handleNumeroLote (newValue) {
      return this.$emit('changeFilter', { numeroLote: newValue})
    },
    handleNumeroProtocolo (newValue) {
      return this.$emit('changeFilter', {numeroProtocolo: newValue})
    },
  },
  computed: {
    statusLabels () {
      return Object
      .keys(pagamentoLoteStatusLabels)
      .filter(key => Boolean(this.statusCount[key]))
      .map(key => ({ text: `${pagamentoLoteStatusLabels[key]} (${this.statusCount[key]})`, value: key }))
    }
  },
  async mounted () {
    const result = await conciliacaoClient.pagamentoLote.getPagamentoLotesStatusesCount({ pagamentoId: this.pagamentoId })

    this.statusCount = result.data.reduce((statuses, data) => {
      statuses[data.status] = data.count

      return statuses
    }, {})
  }
}
</script>
